import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#D8FFFF"
      d="M100.491 48.86a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M20.002 73.963a1.5 1.5 0 0 1 0 2.121l-9.993 9.994a1.5 1.5 0 1 1-2.122-2.121l9.993-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M7.887 73.963a1.5 1.5 0 0 1 2.122 0l9.993 9.994a1.5 1.5 0 1 1-2.122 2.121l-9.993-9.994a1.5 1.5 0 0 1 0-2.121"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      d="M31.198 94.343a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M95.491 18.068a1.5 1.5 0 0 1 1.5 1.5v14.134a1.5 1.5 0 0 1-3 0V19.568a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M86.924 26.636a1.5 1.5 0 0 1 1.5-1.5h14.134a1.5 1.5 0 0 1 0 3H88.424a1.5 1.5 0 0 1-1.5-1.5M72.455 19.255a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M88.302 39.618a4.04 4.04 0 0 0-4.04-4.04H31.739a4.04 4.04 0 0 0-4.041 4.04V47.7h60.604z"
    />
    <path
      fill="#0597A3"
      d="M27.698 47.7V75.98a4.04 4.04 0 0 0 4.041 4.04h52.523a4.04 4.04 0 0 0 4.04-4.04V47.7z"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M37.57 59.82a2.25 2.25 0 0 1 2.25-2.25h22.22a2.25 2.25 0 0 1 0 4.5H39.82a2.25 2.25 0 0 1-2.25-2.25M37.57 67.9a2.25 2.25 0 0 1 2.25-2.25h14.14a2.25 2.25 0 1 1 0 4.5H39.82a2.25 2.25 0 0 1-2.25-2.25"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconCreditCardInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconCreditCardInverted);
export default Memo;
